<template>
  <div class="categoliesBg">
    <!-- 导航栏 -->
    <Header :title="$t('T_SEARCH_SPEC')" link="home"></Header>
    <!-- 选择框 -->
    <div class="appContent size">
      <div class="ellipse-border clearfix categolies-toggle">
        <div
          class="toggle-ellipse-box"
          :class="{ 'checked-ellipse-box ellipse-border-noShadow': radio == 'rangeRadio', 'unchecked-ellipse-box': radio != 'rangeRadio' }"
          @click="changeChecked('rangeRadio')"
        >
          <span>{{ $t('T_SEARCH_BY_RANGE') }}</span>
        </div>
        <div
          class="toggle-ellipse-box"
          :class="{ 'checked-ellipse-box ellipse-border-noShadow': radio == 'textRadio', 'unchecked-ellipse-box': radio != 'textRadio' }"
          @click="changeChecked('textRadio')"
        >
          <span>{{ $t('T_SEARCH_BY_TEXTBOX') }}</span>
        </div>
      </div>
      <div class="panel-box-com">
          <div class="title-com">{{ $t('T_DIMENSION') }}</div>
          <div class="tip-com font-blue" @click="changeModel" v-show="model === 'Imperial'">{{ $t('T_CHANGE_UNIT_TO_IMPERIAL') }}</div>
          <div class="tip-com font-blue" @click="changeModel" v-show="model !== 'Imperial'">{{ $t('T_CHANGE_UNIT_TO_METRIC') }}</div>
          <van-row gutter="20">
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_WIDTH')}}</div>
              <van-field class="toggle-box-item" v-model='width' type="number" :formatter="formatter" format-trigger="onBlur">
                <span slot="button" class="field-tip">{{ unit }}</span>
              </van-field>
          </van-col>
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_HEIGHT')}}</div>
            <van-field class="toggle-box-item" v-model='height' type="number" :formatter="formatter" format-trigger="onBlur">
              <span slot="button" class="field-tip">{{ unit }}</span>
            </van-field>
          </van-col>
          <van-col span="8">
            <div class="text-center font-blue">{{$t('T_DEPTH')}}</div>
            <van-field class="toggle-box-item" v-model='depth' type="number" :formatter="formatter" format-trigger="onBlur">
              <span slot="button" class="field-tip">{{ unit }}</span>
            </van-field>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_BRIGHTNESS') }}</div>
        <van-row gutter="20">
          <van-col span="24" v-show="brightnessSelect">
            <dropdown v-model="brightnessData" :selectData="brightnessOptions" :label="'label'" @change="changeValue('brightness')"></dropdown>
          </van-col>
          <van-col span="24" v-show="!brightnessSelect" class="padding-top-5">
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='brightnessMin' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="2">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='brightnessMax' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="6" @click="backValue('brightness')">_to_lumens</van-col>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_CONTRAST') }}</div>
        <van-row gutter="20">
          <van-col span="24" v-show="constrastSelect">
            <dropdown v-model="constrastData" :selectData="constrastOptions" :label="'label'" @change="changeValue('constrast')"></dropdown>
          </van-col>
          <van-col span="24" v-show="!constrastSelect" class="padding-top-5">
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='constrastMin' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="2">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='constrastMax' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="6" @click="backValue('constrast')">:1</van-col>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_RESOLUTION') }}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="resolutionData" :selectData="resolutionOptions" :label="'label'"></dropdown>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_WEIGHT') }}</div>
        <van-row gutter="20">
          <van-col span="24" v-show="weightSelect">
            <dropdown v-model="weightData" :selectData="weightOptions[weightUnit]" :label="'label'" @change="changeValue('weight')"></dropdown>
          </van-col>
          <van-col span="24" v-show="!weightSelect" class="padding-top-5">
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='weightMin' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="2">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='weightMax' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="6" @click="backValue('weight')">{{ weightUnit }}</van-col>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_FAN_NOISE') }}</div>
        <van-row gutter="20">
          <van-col span="24" v-show="noiseSelect">
            <dropdown v-model="noiseData" :selectData="noiseOptions" :label="'label'" @change="changeValue('noise')"></dropdown>
          </van-col>
          <van-col span="24" v-show="!noiseSelect" class="padding-top-5">
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='noiseMin' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="2">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
            <van-col span="8">
                <van-field class="toggle-box-item" v-model='noiseMax' type="number" :formatter="formatter" format-trigger="onBlur"></van-field>
            </van-col>
            <van-col span="6" @click="backValue('noise')">dB</van-col>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_THROW_RATIO') }}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="throwRatioData" :selectData="throwRatioOptions" :label="'label'"></dropdown>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INFO_LIGHT_TYPE') }}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="lampTypeData" :selectData="lampTypeOptions" :label="'label'"></dropdown>
          </van-col>
        </van-row>
        <div class="panel-box-title">{{ $t('T_INTERFACE') }}</div>
        <van-row gutter="20">
          <van-col span="24">
            <dropdown v-model="interfaceData" :selectData="interfaceOptions" :label="'label'"></dropdown>
          </van-col>
        </van-row>
      </div>
      <div class="btn-box">
        <van-button round type="info" size="large" @click="search">{{ $t('T_SEARCH') }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import dropdown from '@/components/Dropdown'
import Header from '@/components/header'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'specification',
  data () {
    return {
      radio: 'rangeRadio',
      options: [{
        label: '_to_lumens',
        value: 'changeTo'
      }],
      model: 'Imperial',
      width: '586',
      height: '211',
      depth: '492',
      brightnessData: '',
      constrastData: '',
      resolutionData: '',
      weightData: '',
      noiseData: '',
      brightnessSelect: true,
      constrastSelect: true,
      weightSelect: true,
      noiseSelect: true,
      lampTypeData: '',
      throwRatioData: '',
      interfaceData: '',
      brightnessMin: '',
      brightnessMax: '',
      constrastMin: '',
      constrastMax: '',
      weightMin: '',
      weightMax: '',
      weightUnit: 'kgs',
      noiseMin: '',
      noiseMax: '',
      unit: 'mm',
      brightnessOptions: [{
        label: '1000-2000',
        value: '1000-2000'
      }, {
        label: '2001-4000',
        value: '2001-4000'
      }, {
        label: '4001-6000',
        value: '4001-6000'
      }, {
        label: '6001-8000',
        value: '6001-8000'
      }, {
        label: '8001-10000',
        value: '8001-10000'
      }, {
        label: '10001-15000',
        value: '10001-15000'
      }, {
        label: '15001-20000',
        value: '15001-20000'
      }, {
        label: '20001-25000',
        value: '20001-25000'
      }, {
        label: '25001-30000',
        value: '25001-30000'
      }, {
        label: 'Over 30000',
        value: '30000+'
      }, {
        label: '_to_lumens',
        value: 'changeTo'
      }],
      constrastOptions: [{
        label: '-',
        value: '-'
      }, {
        label: '300-1000:1',
        value: '300-1000'
      }, {
        label: '1001-2000:1',
        value: '1001-2000'
      }, {
        label: '2001-3000:1',
        value: '2001-3000'
      }, {
        label: '3001-5000:1',
        value: '3001-5000'
      }, {
        label: '5001-10000:1',
        value: '5001-10000'
      }, {
        label: '10001-20000:1',
        value: '10001-20000'
      }, {
        label: '20001-60000:1',
        value: '20001-60000'
      }, {
        label: '60001-100000:1',
        value: '60001-100000'
      }, {
        label: 'Over 100000:1',
        value: '100000+'
      }, {
        label: '_to_lumens',
        value: 'changeTo'
      }],
      resolutionOptions: [{
        label: 'SVGA　(800 x 600)',
        value: 'SVGA'
      }, {
        label: 'WXGA (1280 x 800)',
        value: 'WXGA'
      }, {
        label: 'SXGA+ (1440  x 1050)',
        value: 'SXGA+'
      }, {
        label: 'WUXGA (1920 x 1200)',
        value: 'WUXGA'
      }, {
        label: 'XGA',
        value: 'XGA'
      }, {
        label: '1080p (1920 x 1080)',
        value: '1080p'
      }, {
        label: '4K (3840 x 2160)',
        value: '4K'
      }],
      weightOptions: {
        kgs: [{
          label: '0-2 kgs',
          value: '0-2'
        }, {
          label: '2-4 kgs',
          value: '2-4'
        }, {
          label: '4-6 kgs',
          value: '4-6'
        }, {
          label: '6-10 kgs',
          value: '6-10'
        }, {
          label: '10-20 kgs',
          value: '10-20'
        }, {
          label: '20+ kgs',
          value: '20+'
        }, {
          label: 'Any Weight',
          value: 'any'
        }, {
          label: '___ to ___ kgs',
          value: 'changeTo'
        }],
        lbs: [{
          label: '0-2 lbs',
          value: '0-2'
        }, {
          label: '2-4 lbs',
          value: '2-4'
        }, {
          label: '4-6 lbs',
          value: '4-6'
        }, {
          label: '6-10 lbs',
          value: '6-10'
        }, {
          label: '10-20 lbs',
          value: '10-20'
        }, {
          label: '20+ lbs',
          value: '20+'
        }, {
          label: 'Any Weight',
          value: 'any'
        }, {
          label: '___ to ___ lbs',
          value: 'changeTo'
        }]
      },
      noiseOptions: [{
        label: '0-22 dB',
        value: '0-22'
      }, {
        label: '22-26 dB',
        value: '22-26'
      }, {
        label: '26-32 dB',
        value: '26-32'
      }, {
        label: '32-40 dB',
        value: '32-40'
      }, {
        label: '40+ dB',
        value: '40+'
      }, {
        label: 'Any Noise Level',
        value: 'any'
      }, {
        label: '___ to ___ dB',
        value: 'changeTo'
      }],
      throwRatioOptions: [{
        label: '0.1 - 0.30',
        value: '0.1-0.30'
      }, {
        label: '0.31 - 0.50',
        value: '0.31-0.50'
      }, {
        label: '0.51 - 1.00',
        value: '0.51-1.00'
      }, {
        label: '1.01 - 1.50',
        value: '1.01-1.50'
      }, {
        label: '1.51 - 2.00',
        value: '1.51-2.00'
      }, {
        label: '2.01 - 3.00',
        value: '2.01-3.00'
      }, {
        label: '3.01 - 5.00',
        value: '3.01-5.00'
      }, {
        label: '5.01 - 7.00',
        value: '5.01-7.00'
      }, {
        label: '7.01 - 10.00',
        value: '7.01-10.00'
      }, {
        label: '10.00 -',
        value: '10.00-'
      }],
      lampTypeOptions: [{
        label: 'Lamp',
        value: 'Lamp'
      }, {
        label: 'Laser',
        value: 'Laser Diode'
      }],
      interfaceOptions: [{
        label: 'HDMI',
        value: 'inputHdmi'
      }, {
        label: 'SDI',
        value: 'SDI'
      }, {
        label: '5BNC',
        value: '5BNC'
      }, {
        label: 'HDBaseT',
        value: 'inputHdBaseT'
      }, {
        label: 'DVI',
        value: 'DVI'
      }, {
        label: 'Computer',
        value: 'inputRgb'
      }, {
        label: 'LAN',
        value: 'inputWiredLan'
      }, {
        label: 'Wireless LAN',
        value: 'inputWirelessLan'
      }, {
        label: 'USB',
        value: 'inputUsbA'
      }]
    }
  },
  computed: {
    ...mapState([])
  },
  watch: {
    radio (value) {
      if (value === 'rangeRadio') {
        this.brightnessSelect = true
        this.constrastSelect = true
        this.weightSelect = true
        this.noiseSelect = true
      } else {
        this.brightnessSelect = false
        this.constrastSelect = false
        this.weightSelect = false
        this.noiseSelect = false
      }
    }
  },
  methods: {
    changeChecked (val) {
      this.radio = val
    },

    changeModel () {
      this.model = this.model === 'Imperial' ? 'Metric' : 'Imperial'
      this.weightUnit = this.weightUnit === 'kgs' ? 'lbs' : 'kgs'
      this.unit = this.unit === 'mm' ? 'inch' : 'mm'
    },

    changeValue (name) {
      if (this[name + 'Data'] === 'changeTo') {
        this[name + 'Select'] = false
        this[name + 'Data'] = ''
      }
    },

    backValue (name) {
      this[name + 'Select'] = true
      this[name + 'Max'] = ''
      this[name + 'Min'] = ''
    },

    search () {
      let result = []
      this.ProjectorSpec.forEach((item) => {
        if (this.filterProjector(item)) {
          result.push(item)
        }
      })
      this.MATCHINGMODELDATA(result)
      this.SEARCHMATCHINGMODELDATA(result)
      this.$router.push({
        path: '/searchProjectors',
        query: {
          noSearch: true,
          link: 'specification'
        }
      })
    },

    filterProjector (projector) {
      let result = true
      // dimension "440 x 120 x 304 mm"
      let dimension = projector.maxDimension.split('mm')[0].trim().split('x')
      let width = this.width
      let height = this.height
      let depth = this.depth
      if (this.unit !== 'mm') {
        width = (this.$commonJs.changeUnit(this.width, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
        height = (this.$commonJs.changeUnit(this.height, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
        depth = (this.$commonJs.changeUnit(this.depth, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
      }
      if ((this.width && Number(dimension[0].trim()) > Number(width)) || (this.height && Number(dimension[1].trim()) > Number(height)) || (this.depth && Number(dimension[2].trim()) > Number(depth))) {
        result = false
      }
      result = this.checkBirghtness(projector, result)
      result = this.checkConstrast(projector, result)
      result = this.checkWeight(projector, result)
      result = this.checkNoise(projector, result)
      result = this.checkThrowRatio(projector, result)
      result = this.checkInterface(projector, result)
      result = this.checkResolution(projector, result)
      result = this.checkLampType(projector, result)
      return result
    },

    // brightness color
    checkBirghtness (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.brightnessSelect && this.brightnessData) {
        if (this.brightnessData === '30000+' && projector.color * 1 < 30001) {
          result = false
        }
        if (this.brightnessData !== '30000+') {
          let brightnessRange = this.brightnessData.split('-')
          if (projector.color * 1 < brightnessRange[0] * 1 || projector.color * 1 > brightnessRange[1] * 1) {
            result = false
          }
        }
      }
      if (!this.brightnessSelect) {
        result = this.$commonJs.matchRange(projector.color, this.brightnessMax, this.brightnessMin)
      }
      return result
    },

    // contrast
    checkConstrast (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.constrastSelect && this.constrastData) {
        if (this.constrastData === '100000+' && (projector.contrast.split(':')[0] * 1 < 100001 || projector.contrast === '-')) {
          result = false
        }
        if (this.constrastData !== '100000+') {
          let constrastRange = this.constrastData.split('-')
          let constrast = projector.contrast.split(':')[0] * 1
          if (this.constrastData === '-' && projector.contrast === '-') {
            result = true
          } else {
            if (constrast < constrastRange[0] * 1 || constrast > constrastRange[1] * 1 || projector.contrast === '-') {
              result = false
            }
          }
        }
      }
      if (!this.constrastSelect) {
        result = this.$commonJs.matchRange(projector.contrast, this.constrastMax, this.constrastMin)
      }
      return result
    },

    // weight weightIncludingLens 58 lbs / 26 kg
    checkWeight (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.weightSelect && this.weightData && this.weightData !== 'any') {
        let weight = this.getWeight(projector)
        if (this.weightData === '20+' && weight * 1 < 20) {
          result = false
        }
        if (this.weightData !== '20+') {
          let weightRange = this.weightData.split('-')
          if (weight < weightRange[0].trim() * 1 || weight > weightRange[1].trim() * 1) {
            result = false
          }
        }
      }
      if (!this.weightSelect) {
        let weight = this.getWeight(projector)
        result = this.$commonJs.matchRange(weight, this.weightMax, this.weightMin)
      }
      return result
    },

    // noise fanNoise
    checkNoise (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.noiseSelect && this.noiseData && this.noiseData !== 'any') {
        let noise = projector.fanNoise.split('dB')[0].trim()
        if (this.noiseData === '40+' && noise * 1 < 41) {
          result = false
        }
        if (this.noiseData !== '40+') {
          let noiseRange = this.noiseData.split('-')
          if (noise < noiseRange[0].trim() * 1 || noise > noiseRange[1].trim() * 1) {
            result = false
          }
        }
      }
      if (!this.noiseSelect) {
        let noise = projector.fanNoise.split('dB')[0].trim()
        result = this.$commonJs.matchRange(noise, this.noiseMax, this.noiseMin)
      }
      return result
    },

    // lamp type lightType : lamp Laser Diode
    checkThrowRatio (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.throwRatioData) {
        var { matchingLensID, selectedLensInfo } = this.$commonJs.findLensInfo(projector)
        let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        if (this.throwRatioData === '10-' && realThrowRatio[0].trim() * 1 > 10) {
          return result
        }
        let ratio = this.throwRatioData.split('-')
        // 只比较最小值
        if (ratio[0] * 1 >= realThrowRatio[0].trim() * 1 || ratio[1] * 1 <= realThrowRatio[0].trim() * 1) {
          // 检测可选镜头有没有匹配的
          if (!this.comparenLesThrowratio(matchingLensID, ratio)) {
            result = false
          }
        }
      }
      return result
    },

    comparenLesThrowratio (matchingLensID, target) {
      let result = false
      if (!result) {
        return false
      }
      for (let i = 0; i < matchingLensID.length; i++) {
        if (result) {
          break
        }
        for (let j = 0; j < this.OptionLensSpec.length; j++) {
          let temp = this.OptionLensSpec[i].throwRatio.split('-')
          if (temp[0].trim() * 1 >= target[0] * 1 && temp[0].trim() * 1 <= target[1] * 1) {
            result = true
            break
          }
        }
      }
      return result
    },

    // interface
    checkInterface (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.interfaceData) {
        let interfaceValue = projector[this.interfaceData]
        if (!interfaceValue || interfaceValue === '-') {
          result = false
        }
      }
      return result
    },

    // resolution
    checkResolution (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.resolutionData) {
        let resolution = projector.resolution
        if (this.resolutionData === '1080p' && (resolution !== '1080p' && resolution !== 'FWXGA' && resolution !== 'Full HD' && resolution !== 'FullHD' && resolution !== 'Full HD and 4KE' && resolution !== '1080p and 4KE')) {
          result = false
        }
        if (this.resolutionData !== '1080p' && this.resolutionData !== resolution) {
          result = false
        }
        if (this.resolutionData === '1080p' && resolution === '1080p') {
          result = true
        }
        if (this.resolutionData === 'WUXGA' && (resolution === 'WUXGA' || resolution === 'WUXGA and 4KE')) {
          result = true
        }
      }
      return result
    },

    // lamp type
    checkLampType (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.lampTypeData) {
        let lightType = projector.lightType
        if (lightType.indexOf(this.lampTypeData) < 0) {
          result = false
        }
      }
      return result
    },

    getWeight (projector) {
      let weightArray = projector.weightIncludingLens.split('/')
      if (weightArray.length === 1) {
        return weightArray[0].trim()
      }
      let weightLbs = projector.weightIncludingLens.split('/')[0].split('lbs.')[0]
      if (weightLbs.indexOf('Approx.') > -1) {
        weightLbs = weightLbs.split('Approx.')[1].trim()
      } else if (weightLbs.indexOf('Under') > -1) {
        weightLbs = weightLbs.split('Under')[1].trim()
      }
      let weightKg = projector.weightIncludingLens.split('/')[1].toLowerCase().split('kg')[0].trim()
      return this.weightUnit === 'kgs' ? weightKg : weightLbs
    },

    formatter (value) {
      if (value === '') {
        return value
      }
      return (value * 1).toFixed(1) * 1
    },

    ...mapMutations([
      'MATCHINGMODELDATA',
      'SEARCHMATCHINGMODELDATA'
    ])
  },
  created () {
  },
  mounted () {

  },
  destroyed () {

  },
  components: {
    dropdown,
    Header
  }
}
</script>

<style scoped>
    .appContent {
        padding-bottom: 20px;
    }

    .padding-top-5 {
        padding-top: 5px;
    }
</style>
